import { useEffect, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import publicApi from "@/lib/publicApi";
import { Button } from "@/components/ui/button";
import { Loader2, Phone, Snowflake } from "lucide-react";

export default function GuidePage() {
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const code = searchParams.get("r");
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [guide, setGuide] = useState(null);

  useEffect(() => {
    publicApi.get(`/public/guides/${slug}`)
      .then((r) => setGuide(r.data))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center bg-[#F7F7F8]"><Loader2 className="h-6 w-6 animate-spin text-[#0055FF]" /></div>;
  }
  if (notFound || !guide) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F7F7F8] px-6">
        <p className="text-[#71717A]" data-testid="guide-page-not-found">This guide is not available.</p>
      </div>
    );
  }

  const company = guide.company || {};
  const mainPhone = company.phones?.[0];
  const leadFormHref = code ? `/l/${code}` : "#";

  return (
    <div className="min-h-screen bg-[#F7F7F8] px-4 py-8" data-testid="public-guide-page">
      <div className="max-w-xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          {company.logo_url ? (
            <img src={company.logo_url} alt={company.name} className="h-10 w-10 rounded-sm object-cover" />
          ) : (
            <div className="h-10 w-10 rounded-sm bg-[#0055FF] grid place-items-center">
              <Snowflake className="h-5 w-5 text-white" />
            </div>
          )}
          <div>
            <p className="font-heading font-bold text-[#09090B]" data-testid="guide-page-company-name">{company.name}</p>
            {mainPhone && (
              <a href={`tel:${mainPhone}`} className="text-xs text-[#0055FF] flex items-center gap-1">
                <Phone className="h-3 w-3" /> {mainPhone}
              </a>
            )}
          </div>
        </div>

        <div className="bg-white rounded-md border border-[#E4E4E7] p-6">
          <h1 className="font-heading text-2xl font-bold text-[#09090B]" data-testid="guide-page-title">{guide.title}</h1>
          <div
            className="prose prose-sm max-w-none mt-4 text-[#27272A]"
            data-testid="guide-page-body"
            dangerouslySetInnerHTML={{ __html: guide.body }}
          />

          <div className="mt-6 border-t border-[#E4E4E7] pt-6 text-center">
            <Link to={leadFormHref} data-testid="guide-page-cta">
              <Button className="bg-[#0055FF] hover:bg-[#0044CC] rounded-md w-full sm:w-auto px-8">
                {guide.cta_text || "Get a free quote"}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
